module.exports = __webpack_public_path__ + "static/media/Ironman-Auckland-2014-Jenny.de5d4c51.png";